import Nav from 'components/Nav';
import Spacer from 'components/Spacer';
import Content from 'components/Content';
import Typography from 'components/Typography';
import Button from 'components/Button';
import classes from 'styles/pages/Amazon.module.scss';

import { AMAZON_ESTATE_REGISTRATION } from 'utils/constants/urls';

const navLinks = [];
const goToPage = () => {
  window.location = AMAZON_ESTATE_REGISTRATION;
};

const Amazon = () => (
  <>
    <Nav links={navLinks} depLoginUrl={AMAZON_ESTATE_REGISTRATION} />
    <main role="main">
      <Content className={classes.videoSection}>
        <div>
          <img src="amazon-benefits.png" alt="" className={classes.logo} />
        </div>
        <Spacer v={32} />

        <Typography style={{ fontSize: '35px' }}>
          Watch the short video below to learn why estate planning is important.
        </Typography>

        <Spacer v={40} />

        <div>
          <video muted controls poster="amazon-thumbnail.png" className={classes.video}>
            <source src="AMAZON-ESTATE-PLANNING-VIDEO.mp4" type="video/mp4" />
          </video>
        </div>

        <Spacer v={24} />

        <Typography className={classes.text}>
          Create an account using a personal email to complete a free estate plan online by April
          30th!
        </Typography>

        <Spacer v={34} />

        <Button color="blue" filled noMinWidth onClick={goToPage} className={classes.button}>
          Get Started
        </Button>
      </Content>
      <Spacer v={32} />
    </main>
  </>
);

export default Amazon;
